import {utils} from "@utils";
import React from "react";
import styles from "./style.module.scss";
import {Images} from "@assets";

interface IProps {
  src?: string;
  className?: string | string[];
}

export default function Img({src, className}: IProps) {
  const classList = [
    styles.img,
    ...(Array.isArray(className) ? className : [className]),
  ].filter(utils.isDefined);

  if (!src) {
    return <></>;
  }

  return (
    <img
      src={src || Images.noImage}
      onError={e => {
        e.currentTarget.src = Images.noImage;
      }}
      className={[styles.img, ...classList].join(" ")}
    />
  );
}
